import { useIntl } from 'react-intl'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import { useEffect } from 'react'
import { Form, Formik } from 'formik'
import { nylasGoogleInitialValues, nylasMicrosoftInitialValues } from '../core/_constants'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import ConnectAccountModal from './ConnectAccountModal'
import { useState } from 'react'
// import {InfoCard} from '../../widgets/components/UI/InfoCard'
import { toast } from 'react-toastify'
import { getUserInfo, disconnectNylas } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import ConfirmationModal from './DeleteConfirmation'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'
import brandingConfig from '../../../../config/brandingConfig'

export default function TeamCalendar({
  key,
  companyId,
  getMailInformation,
  nylasGoogleRadio,
  nylasMicrosoftRadio,
  nylasEmailSignature,
  connectedAccount,
  setconnectedAccount,
}: {
  key: number
  companyId?: number
  getMailInformation: () => Promise<void>
  nylasGoogleRadio?: any
  nylasMicrosoftRadio?: any
  nylasEmailSignature: string
  connectedAccount: any
  setconnectedAccount: any
}) {
  const [sendTestEmailLoading] = useState(false)
  const { formatMessage } = useIntl()
  const [accountType, setaccountType] = useState('')
  const onSubmit = async (values: any) => {
    console.log(values)
    console.log(sendTestEmailLoading)
  }
  const [isActive, setIsActive] = useState(false)
  const [userLoading, setuserLoading] = useState(false)
  const [userInfo, setuserInfo] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [userName, setuserName] = useState('')
  const [userEmail, setuserEmail] = useState('')
  const { currentUser } = useAuth()

  function handleIsActive() {
    setIsActive(() => !isActive)
  }

  const getUserInformation = async () => {
    setuserLoading(true)
    try {
      const {
        data: { success, error, data },
      } = await getUserInfo(companyId!)
      if (success) {
        setuserInfo(data?.account?.data?.email)
        const firstName = data?.mailerData?.user?.firstName
        const lastName = data?.mailerData?.user?.lastName || ''
        setuserName(firstName + (lastName ? ` ${lastName}` : ''))
        setuserEmail(data?.mailerData?.user?.email)
      } else {
        toast.error(formatMessage({ id: error }))
      }
    } catch (err) {
      console.log(err)
    } finally {
      setuserLoading(false)
    }
  }

  const handleDisconnectButton = () => {
    setIsModalOpen(true)
  }

  const handleConfirmDisconnect = async () => {
    setIsProcessing(true)
    try {
      const isNylasActive = 'disconnect'
      const {
        data: { data, success, errors }, // eslint-disable-line
      } = await disconnectNylas(isNylasActive, companyId)

      if (success) {
        toast.success(formatMessage({ id: 'Account is successfully disconnected.' }))
        setconnectedAccount('')
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DisconnectNylasSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              provider: isNylasActive,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(errors[0])
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DisconnectNylasFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              provider: isNylasActive,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
      }
    } catch (error) {
      toast.error(formatMessage({ id: 'Something went wrong while disconnecting your account.' }))
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DisconnectNylasFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: error,
          },
        },
      })
    } finally {
      setIsProcessing(false)
      setIsModalOpen(false)
    }
  }

  useEffect(() => {
    if (connectedAccount) {
      getUserInformation()
    }
  }, [connectedAccount]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='card row'>
        <div className='card-body p-3'>
          <div>
            <div>
              <h4 className='card-label'>
                {formatMessage({ id: 'Calendar Integration' })}
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'Choose between your Google Workspace or Microsoft 365 Business calendar for a seamless workflow between your scheduling platform and document management system.',
                  })}
                />
              </h4>
            </div>

            <div className='row mt-4 mb-4'>
              <div className='col-md-7'>
                {connectedAccount === '' || !userInfo ? (
                  userLoading ? (
                    <div>
                      <Skeleton
                        width={200}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                      <Skeleton
                        count={2}
                        width={500}
                        style={{ marginTop: '12px' }}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  ) : (
                    <div className='d-flex justify-content-center align-items-center col-md-12 mb-10 mt-4'>
                      <div
                        className='btn-group d-flex flex-md-row flex-column w-100 justify-content-between'
                        role='group'
                        aria-label='Connect buttons'
                      >
                        <Formik initialValues={nylasGoogleInitialValues} onSubmit={onSubmit}>
                          {(formik) => {
                            return (
                              <Form className='w-100'>
                                <button
                                  type='button'
                                  id='googleConnectButton'
                                  className='btn btn-lg rounded d-flex justify-content-center w-100'
                                  style={{
                                    border: '1px solid #4776E6',
                                    color: '#4776E6',
                                  }}
                                  onClick={() => {
                                    setaccountType('google')
                                    handleIsActive()
                                  }}
                                >
                                  <img
                                    src={toAbsoluteUrl('/media/auth/google-calendar.svg')}
                                    alt='Google'
                                    height={21}
                                    width={21}
                                    style={{ marginRight: '8px' }}
                                  />
                                  <p className='m-0 connected-acc-button-text'>
                                    {formatMessage({ id: 'Connect Now' })}
                                  </p>
                                </button>
                              </Form>
                            )
                          }}
                        </Formik>
                        <p className='align-self-center m-0 mx-2'>{formatMessage({ id: 'Or' })}</p>
                        <Formik initialValues={nylasMicrosoftInitialValues} onSubmit={onSubmit}>
                          {(formik) => {
                            return (
                              <Form className='w-100'>
                                <button
                                  type='button'
                                  id='nylasMicrosoft'
                                  className='btn btn-lg rounded d-flex justify-content-center w-100'
                                  style={{ border: '1px solid #4776E6', color: '#4776E6' }}
                                  onClick={() => {
                                    setaccountType('microsoft')
                                    handleIsActive()
                                  }}
                                >
                                  <img
                                    src={toAbsoluteUrl('/media/auth/ic_calendar.svg')}
                                    alt='Microsoft'
                                    height={21}
                                    width={21}
                                    style={{ marginRight: '8px' }}
                                  />
                                  <p className='m-0 connected-acc-button-text'>
                                    {formatMessage({ id: 'Connect Now' })}
                                  </p>
                                </button>
                              </Form>
                            )
                          }}
                        </Formik>
                        <ConnectAccountModal
                          isActive={isActive}
                          setIsActive={setIsActive}
                          handleIsActive={handleIsActive}
                          accountType={accountType}
                          connectedAccount={connectedAccount}
                        />
                      </div>
                    </div>
                  )
                ) : (connectedAccount === 'google' || connectedAccount === 'microsoft') &&
                  userInfo ? (
                  <div className='d-flex flex-column justify-content-center align-items-start col-md-7 mb-10 mt-4'>
                    <div
                      className='btn-group d-flex flex-md-row flex-column w-100 justify-content-between'
                      role='group'
                      aria-label='Connect buttons'
                    >
                      {userLoading ? (
                        <Skeleton
                          width={200}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <button
                          type='button'
                          id='googleConnectButton'
                          className='btn btn-lg rounded d-flex justify-content-center '
                          style={{
                            border: '1px solid #4776E6',
                            color: '#4776E6',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '13px',
                            lineHeight: '20px',
                            textAlign: 'right',
                          }}
                        >
                          <img
                            src={
                              connectedAccount === 'google'
                                ? toAbsoluteUrl('/media/auth/google-calendar.svg')
                                : toAbsoluteUrl('/media/auth/ic_calendar.svg')
                            }
                            alt={connectedAccount}
                            height={21}
                            width={21}
                            style={{ marginRight: '8px' }}
                          />
                          <p
                            className='m-0 connected-acc-button-text'
                            style={{
                              fontFamily: 'Poppins',
                              fontWeight: '400',
                              fontSize: '13px',
                              lineHeight: '20px',
                              textAlign: 'right',
                              whiteSpace: 'nowrap',
                              color: '#4776E6',
                            }}
                          >
                            {`${formatMessage({ id: 'Connected' })} ${userInfo}`}
                          </p>
                        </button>
                      )}
                    </div>
                    {userLoading ? (
                      <Skeleton
                        count={2}
                        width={500}
                        style={{ marginTop: '12px' }}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    ) : (
                      <>
                        <p
                          className='mt-2'
                          style={{
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '11px',
                            lineHeight: '20px',
                            color: '#585960',
                            marginBottom: '0px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {userName &&
                            formatMessage({
                              id: `Connected by ${userName} ${userEmail && `(${userEmail})`}`,
                            })}
                        </p>
                        <p
                          className='mt-0'
                          onClick={handleDisconnectButton}
                          style={{
                            color: '#4776E6',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '11px',
                            lineHeight: '20px',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          {formatMessage({ id: 'Disconnect Now' })}
                        </p>
                      </>
                    )}
                  </div>
                ) : null}
                <ConfirmationModal
                  isOpen={isModalOpen}
                  onRequestClose={() => setIsModalOpen(false)}
                  onConfirm={handleConfirmDisconnect}
                  isProcessing={isProcessing}
                />

                {/* connected buttons */}
                {/* <div className='col-md-7 gap-4'>
                  <button
                    type='button'
                    id='nylasMicrosoft'
                    className='btn btn-lg rounded d-flex justify-content-center w-100 w-md-75 mb-3 connected-acc-button'
                    // onClick={
                    //   handleIsActive
                    //   // redirectToNylasOauthUrl('microsoft')
                    // }
                  >
                    <img
                      src={toAbsoluteUrl('/media/auth/google-calendar.svg')}
                      alt='Microsoft'
                      height={21}
                      width={21}
                      style={{marginRight: '8px'}}
                    />
                    <p className='m-0 connected-acc-button-text'>
                      {formatMessage({id: 'Connected me@toshendra.com'})}
                    </p>
                  </button>
                  <button
                    type='button'
                    id='nylasMicrosoft'
                    className='btn btn-lg rounded d-flex justify-content-center w-100 w-md-75 mb-3 connected-acc-button'
                    // onClick={
                    //   handleIsActive
                    //   // redirectToNylasOauthUrl('microsoft')
                    // }
                  >
                    <img
                      src={toAbsoluteUrl('/media/auth/ic_calendar.svg')}
                      alt='Microsoft'
                      height={21}
                      width={21}
                      style={{marginRight: '8px'}}
                    />
                    <p className='m-0 connected-acc-button-text'>
                      {formatMessage({id: 'Connected me@toshendra.com'})}
                    </p>
                  </button>
                  <p className='m-0 mb-2'>
                    {formatMessage({
                      id: 'Connected on 5 Jan, 2024 at 3:45 PM by Toshendra Sharma ',
                    })}
                    (me@toshendra.com)
                  </p>
                  <p className='m-0 mb-2 text-primary cursor-pointer text-decoration-underline'>
                    {formatMessage({id: 'Disconnect Now'})}
                  </p>
                </div> */}
              </div>
              <div className='col-md-5'>
                <div className='info-card important-notice-card'>
                  <div className='card mt-0 fs-6 flex-row mb-md-4 mb-8 '>
                    <div className='me-4'>
                      <img
                        src={toAbsoluteUrl('/media/icons/duotune/general/file_image.svg')}
                        alt=''
                      />
                    </div>
                    <div>
                      <div className=' fw-bold mb-1'>
                        {formatMessage({ id: 'How Calendar Integration Works?' })}
                      </div>
                      <div className='fw-normal'>
                        <p>
                          {formatMessage({
                            id: `You can connect either your Google Workspace or Microsoft 365 Business account for calendar integration. This allows you to sync the connected account's calendar with the Team Calendar within ${brandingConfig.brandName}, available in the “Shared Access” section.`,
                          })}
                        </p>
                        <p>
                          {formatMessage({
                            id: 'The account connected here will also automatically integrate with Transactional Emails and Contacts, and vice versa.',
                          })}
                        </p>
                      </div>

                      <div className='d-flex justify-content-end'>
                        <a
                          href='https://help.recordskeeper.ai/en/articles/10979019-how-calendar-integration-simplifies-compliance-and-team-coordination'
                          className='ms-1 link-primary'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {formatMessage({ id: 'Learn More' })}
                          <span className='ms-5'>
                            <img
                              src={toAbsoluteUrl('/media/icons/duotune/general/arrow-right.svg')}
                              alt=''
                            />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
